import { Operation } from 'urql';

// Type for a mock handler function
export type MockHandler = (operation: Operation) => unknown;

// Type for the handlers registry
export type MockHandlers = Record<string, MockHandler>;

// Helper to create partial mocks without requiring all fields
export const createPartialMock = <T>(partial: Partial<T>): T => {
  return partial as T;
};
